export const getCloudinaryLink = (link) => {
    if (!link) return null;
    const hasBackendUrl = link.includes(process.env.REACT_APP_SERVER_BASE_URL);
    if (!hasBackendUrl) {
        return link;
    }
    link.split(process.env.REACT_APP_SERVER_BASE_URL);
    return link[1];
}